// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Yz2-","options":"AnswerScale_options__2R8L9","selected":"AnswerScale_selected__2WXcz"};